// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1cFdx","header":"PatientQuestionnaire_header__1owK3","info":"PatientQuestionnaire_info__BIBLd"};